import { CountryService } from "./../../../services/catalogs/CountryService";
import { CountryDetail } from "./../../../components/Pages/Catalogs/Country/CountryDetail";
import { CreateCountryDto } from "./../../../dtos/catalogs/country/CreateCountryDto";
import React from "react";
import { CatalogService } from "../../../services/catalogs/CatalogService";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupCountry } from "../../../components/Shared/NewForms/NFLookupCountry";
import CountryList from "../../../components/Pages/Catalogs/Country/CountryList";

export const Country: IAppEntity = {
  entityType: "catalog",
  title: "Country",
  pluralTitle: "Country",
  apiUrl: "Countries",
  apiEnum: ReferenceTypes.CatalogCountry,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(CountryDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(CountryList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupCountry, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new CountryService("Countries"),
  getEmptyModel: () => {
    const model: CreateCountryDto = {
      name: "",
      createdDate: new Date(),
    };
    return model;
  },
};
